import React from 'react';

const FilterIcon = () => {
  return (
    <svg
      stroke="#222222"
      fill="#222222"
      strokeWidth="0"
      viewBox="0 0 16 16"
      height="20px"
      width="20px"
    >
      <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"></path>
    </svg>
  );
};

export default FilterIcon;
